import React, { useState } from "react";
import { tokens } from "../../../theme";
import { MenuItem, SubMenu } from "react-pro-sidebar";
import { Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import FactoryIcon from "@mui/icons-material/Factory";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import { hasPermission } from "../../../utils/permissions";

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const VidrioGranular = ({ permissionKeys = [] }) => {
  const [selected, setSelected] = useState("Dashboard");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const canEntrada = hasPermission(permissionKeys, "VIDRIO.LINEA.AUTOCLAVE_ENT");
  const canHistorial = hasPermission(permissionKeys, "VIDRIO.LINEA.AUTOCLAVE_HIST");
  const canReceta = hasPermission(permissionKeys, "VIDRIO.LINEA.AUTOCLAVE_RECETA");
  const canSalida = hasPermission(permissionKeys, "VIDRIO.LINEA.AUTOCLAVE_SAL");

  const hasAnyAutoClave = canEntrada || canHistorial || canReceta || canSalida;

  if (!hasAnyAutoClave) {
    return null;
  }

  return (
    <SubMenu
      title="Vidrio"
      icon={<FactoryIcon />}
      style={{ color: colors.grey[300] }}
    >
      <SubMenu
        title="AutoClave"
        icon={<FactoryIcon />}
        style={{ color: colors.grey[300] }}
      >
        {canHistorial && (
          <Item
            title="Historial"
            to="/view/historial"
            icon={<AccessTimeIcon />}
            selected={selected}
            setSelected={setSelected}
          />
        )}
        {canReceta && (
          <Item
            title="Registro Recetas"
            to="/registro/receta"
            icon={<PrecisionManufacturingIcon />}
            selected={selected}
            setSelected={setSelected}
          />
        )}
        {canEntrada && (
          <Item
            title="Registrar Entrada"
            to="/registro/autoClave"
            icon={<PrecisionManufacturingIcon />}
            selected={selected}
            setSelected={setSelected}
          />
        )}
        {canSalida && (
          <Item
            title="Salida AutoClave"
            to="/registro/salidaAutoclave"
            icon={<PrecisionManufacturingIcon />}
            selected={selected}
            setSelected={setSelected}
          />
        )}
      </SubMenu>
    </SubMenu>
  );
};

export default VidrioGranular;
